// Data service for country/subdivision/city data.
//
// Fetches from the CDN/S3 baseUrl. The URL structure (relative to baseUrl):
//   <baseUrl>/countries.json
//   <baseUrl>/countries/{iso2}/subdivisions.json
//   <baseUrl>/countries/{iso2}/subdivisions/{state_code}/cities.json
//   <baseUrl>/countries/{iso2}/cities.json   (all cities for a country, used when subdivision is hidden)
//   <parent-of-baseUrl>/labels.json          (shared labels/translations, one level up)

const fetchJson = async (url) => {
  const response = await fetch(url);
  if (!response.ok) throw new Error(`[dataService] ${response.status} ${url}`);
  const json = await response.json();
  // All files use a { data: [...] } envelope
  return json.data ?? json;
};

export const fetchCountries = async (baseUrl) =>
  fetchJson(`${baseUrl}/countries.json`);

const normalizeSubdivisions = (data) =>
  data.map(({ code, ...rest }) => ({ ...rest, state_code: code }));

export const fetchSubdivisions = async (countryIso2, baseUrl) => {
  try {
    const data = await fetchJson(
      `${baseUrl}/countries/${countryIso2}/subdivisions.json`,
    );
    return normalizeSubdivisions(data);
  } catch {
    // No subdivisions file means the country has no subdivisions
    return [];
  }
};

export const fetchCities = async (countryIso2, stateCode, baseUrl) =>
  fetchJson(
    `${baseUrl}/countries/${countryIso2}/subdivisions/${stateCode}/cities.json`,
  );

// labels.json sits one directory above the language-specific base URL
// e.g. baseUrl = ".../address/en" → labels URL = ".../address/labels.json"
export const fetchLabels = async (baseUrl) => {
  const labelsUrl = new URL('../labels.json', `${baseUrl}/`).href;
  return fetchJson(labelsUrl);
};

export const fetchCitiesForCountry = async (countryIso2, baseUrl) =>
  fetchJson(`${baseUrl}/countries/${countryIso2}/cities.json`);
